import React from 'react';
import { Hero } from '../assets'; // Make sure the Hero image is correctly imported
import Waves from './Waves';
import './Hero.css'; // Import custom styles
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const HeroSection = () => {
  return (
    <div className="hero-wrapper">
      <Waves
        lineColor="#99008C"
        backgroundColor="#000"
        waveSpeedX={0.02}
        waveSpeedY={0.01}
        waveAmpX={40}
        waveAmpY={20}
        maxCursorMove={120}
        xGap={12}
        yGap={36}
      />

      <div className="container py-5" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row align-items-center g-5 py-5">
          {/* TEXT FIRST ON MOBILE */}
          <div className="col-lg-6 order-1 order-lg-1 text-white text-center text-lg-start">
            <h1 className="display-5 fw-bold lh-1 mb-3">
              <span className="gradient-text">Oracle NetSuite</span> Services <br />
            </h1>
            <p className="lead mb-4 mt-4">
              Empowering businesses to streamline operations, boost productivity, and drive growth with customized NetSuite implementation and support.
            </p>
            <div className="d-grid gap-3 d-md-flex justify-content-center justify-content-lg-start mb-4">
              <button type="button" className="btn btn-light btn-lg px-4 me-md-2 fw-bold"><Link className="nav-link" to="/contact">Get Started</Link>
                
              </button>
             
            </div>
            <p className="text-light-50 mt-3 small">
              <span className="me-3">✓ Certified Experts</span>
              <span className="me-3">✓ 24/7 Support</span>
              <span>✓ 100+ Successful Implementations</span>
            </p>
          </div>

          {/* IMAGE SECOND ON MOBILE */}
          <motion.div 
            className="col-12 col-sm-10 col-md-8 col-lg-6 mx-auto order-2 order-lg-2"
            initial={{ opacity: 0, x: 50, scale: 0.9 }}
            animate={{ 
              opacity: 1, 
              x: 0,
              scale: 1
            }}
            transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
            whileInView={{
              y: [0, -15, 0],
              rotate: [0, 1, -1, 0]
            }}
            viewport={{ once: false }}
            style={{
              animation: 'floatImage 8s ease-in-out infinite'
            }}
          >
            <motion.div 
              className="hero-image-container"
              whileHover={{ scale: 1.05, rotate: 2 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <motion.img
                src={Hero}
                className="img-fluid hero-image w-100"
                alt="Oracle NetSuite"
                loading="lazy"
                style={{ 
                  maxHeight: '500px',
                  objectFit: 'contain',
                  objectPosition: 'center'
                }}
                animate={{
                  y: [0, -10, 5, -5, 0],
                  rotate: [0, 0.5, -0.5, 0.3, 0]
                }}
                transition={{
                  duration: 6,
                  ease: "easeInOut",
                  repeat: Infinity,
                  repeatType: "reverse"
                }}
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
